import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const GenresAndLanguagesRow = styled.div`
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};

  display: flex;
  flex-direction: row;
`

export const RowLabel = styled.span`
  margin-right: 8px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};
  white-space: nowrap;
`
